import { createFileRoute } from '@tanstack/react-router';

import { requireAuth } from '@/app/lib/auth-guard';
import { AddCheckPage } from '@/billing/pages/add-check';

export const Route = createFileRoute('/billing/payment-methods/new-check')({
  beforeLoad: async (ctx) => {
    await requireAuth(ctx);
  },
  component: NewCheckRoute,
  staticData: {
    headerSection: 'billing'
  }
});

function NewCheckRoute() {
  return <AddCheckPage/>;
}
